interface TrackingPayload {
  [key: string]: string | number | boolean | undefined;
}

export function track(event: string, payload?: TrackingPayload): void {
  // Console logging for development
  console.log('[Tracking Event]', event, payload);

  // Google Analytics 4
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', event, payload);
  }

  // Meta Pixel
  if (typeof window !== 'undefined' && (window as any).fbq) {
    (window as any).fbq('trackCustom', event, payload);
  }

  // Additional tracking platforms can be added here
}

// Export trackEvent as an alias for track
export const trackEvent = track;

export const TRACKING_EVENTS = {
  FILTER_START: 'filter_start',
  STEP_COMPLETE: 'step_complete',
  ANSWERED_Q1: 'answered_q1',
  ANSWERED_Q2: 'answered_q2',
  ANSWERED_Q3: 'answered_q3',
  ANSWERED_Q4: 'answered_q4',
  ANSWERED_Q5: 'answered_q5',
  ANSWERED_Q6: 'answered_q6',
  ANSWERED_Q7: 'answered_q7',
  QUALIFIED: 'qualified',
  DISQUALIFIED: 'disqualified',
  CONTINUE_CLICKED: 'continue_clicked',
  SUBMIT: 'submit',
  SUMMARY_VIEW: 'summary_view',
  REDIRECT_CLICK: 'redirect_click',
  CITY_SELECTED: 'city_selected',
  FUNDING_TYPE_SELECTED: 'funding_type_selected',
  INDUSTRY_SELECTED: 'industry_selected',
  FUNDING_PURPOSE_SELECTED: 'funding_purpose_selected'
};

// Initialize tracking on page load
export function initializeTracking() {
  if (typeof window === 'undefined') return;

  // Google Analytics initialization hook
  // Add your GA4 measurement ID in index.html
  console.log('[Tracking] Ready for GA4 and Meta Pixel events');
}
